import React from 'react';
import { DocMessage } from '@/components/chat/Message/DocMessage/DocMessage';
import { MediaMessage } from '@/components/chat/Message/MediaMessage/MediaMessage';
import { TextMessage } from '@/components/chat/Message/TextMessage/TextMessage';
import { type FileMessageProps } from './types';

export const FileMessage = React.memo<FileMessageProps>(({ message }) => {
  return (
    <>
      <TextMessage message={message} />
      <DocMessage message={message} />
      <MediaMessage message={message} />
    </>
  );
});

FileMessage.displayName = 'FileMessage';
